/********************************************************************************
 * Copyright (c) 2021,2022,2023 T-Systems International GmbH
 * Copyright (c) 2022,2023 Contributors to the Eclipse Foundation
 *
 * See the NOTICE file(s) distributed with this work for additional
 * information regarding copyright ownership.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Apache License, Version 2.0 which is available at
 * https://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations
 * under the License.
 *
 * SPDX-License-Identifier: Apache-2.0
 ********************************************************************************/
import { PageSnackbar } from 'cx-portal-shared-components';
import { useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from '../store';
import { toggleSnackbar } from './slice';

export default function Notification() {
  const { openSnackBar, snackBarMessage, snackbarType } = useAppSelector(state => state.notificationSlice);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  return (
    <PageSnackbar
      autoClose
      description={t(snackBarMessage)}
      open={openSnackBar}
      severity={snackbarType}
      showIcon
      onCloseNotification={() => dispatch(toggleSnackbar())}
    ></PageSnackbar>
  );
}
